import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../lib/firebase';
import { checkUserRole } from '../lib/auth';
import { Navbar } from '../components/home/Navbar';
import { HeroSection } from '../components/home/HeroSection';
import { FoundationsSection } from '../components/home/FoundationsSection';
import { BenefitsSection } from '../components/home/BenefitsSection';
import { HowItWorksSection } from '../components/home/HowItWorksSection';
import { AudienceSection } from '../components/home/AudienceSection';
import { BarriersSection } from '../components/home/BarriersSection';
import { GainsSection } from '../components/home/GainsSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';

export function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const role = await checkUserRole(user.uid);
          switch (role) {
            case 'admin':
              navigate('/admin');
              break;
            case 'partner':
              navigate('/partner');
              break;
            case 'coach':
              navigate('/coach');
              break;
            case 'respondent':
              navigate('/dashboard');
              break;
          }
        } catch (error) {
          console.error('Error checking user role:', error);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <HeroSection />
      <FoundationsSection />
      <BenefitsSection />
      <HowItWorksSection />
      <AudienceSection />
      <BarriersSection />
      <GainsSection />
      <TestimonialsSection />
    </div>
  );
}